import React from 'react';

import MenuManagementContext from 'context/MenuManagementContext';
import PropTypes from 'prop-types';

import useProvideMenuManagement from 'hooks/useProvideMenuManagement';

export function MenuManagementProvider({ children }) {
  const menuManagement = useProvideMenuManagement();
  return (
    <MenuManagementContext.Provider value={menuManagement}>
      {children}
    </MenuManagementContext.Provider>
  );
}

MenuManagementProvider.propTypes = {
  children: PropTypes.node,
};

export default MenuManagementProvider;
